import { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Vim através do site e gostaria de solicitar uma análise financeira gratuita.",
    );
    const whatsappNumber = "553397070278";
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;

    window.open(whatsappURL, "_blank");
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-bounce"
          aria-label="Falar no WhatsApp"
        >
          <Icon name="MessageCircle" size={28} className="text-white" />

          {/* Pulse animation */}
          <div className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></div>

          {/* Tooltip */}
          <div
            className={`absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap transition-all duration-200 ${
              isHovered
                ? "opacity-100 translate-x-0"
                : "opacity-0 translate-x-2 pointer-events-none"
            }`}
          >
            Fale conosco agora!
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900"></div>
          </div>
        </button>
      </div>

      {/* Notification Badge */}
      <div
        className={`fixed bottom-24 right-6 z-40 bg-white rounded-lg shadow-lg border max-w-xs transition-all duration-500 ${
          !isHovered && isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <div className="p-4">
          <div className={"flex items-start space-x-3"}>
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="MessageCircle" size={20} className="text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900">
                TJEP Soluções Financeiras
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Olá! Como posso ajudá-lo com suas finanças hoje?
              </p>
              <div className="flex items-center mt-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-xs text-gray-400 ml-2">Online agora</span>
              </div>
            </div>
            <button
              className="text-gray-400 hover:text-gray-600 transition-colors"
              onClick={() => setIsVisible(false)}
              aria-label="Fechar notificação"
            >
              <Icon name="X" size={16} />
            </button>
          </div>
        </div>
        {/* Speech bubble tail */}
        <div className="absolute bottom-0 right-8 transform translate-y-full">
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white"></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-gray-200 transform -translate-y-px"></div>
        </div>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
